module.exports = __webpack_public_path__ + "6506c22592c65b2b87eccecad0809028.svg";